import { createContext, useContext, useState } from "react";

const NavigationContext = createContext();

export function NavigationProvider({ children }) {
  const [source, setSource] = useState(null);
  return (
    <NavigationContext.Provider value={{ source, setSource }}>
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigationSource() {
  return useContext(NavigationContext);
}
